
import { Component, Vue } from "vue-property-decorator";
import AuthHelper from "@/services/AuthHelper";
import { Action } from "vuex-class";

@Component
export default class Login extends Vue {
  @Action("auth/generateCodeVerifier") generateCodeVerifier!: () => string;

  render() {
    return null;
  }

  async created() {
    const codeVerifier = await this.generateCodeVerifier();

    const authHelper = new AuthHelper();
    const uri = authHelper.generateAuthorizeUri(codeVerifier);

    window.location.href = uri;
  }
}
